<div *ngIf="vm.metadata" [ngSwitch]="vm.metadata.type">
	<p id="chatTranslatedMessageItem" *ngSwitchCase="'TRANSLATE_TEXT'" class="c-text c-text--wrap" [ngClass]="{'c-text--bold' : vm.isBold, 'c-text--cut': vm.isPreview}">
		{{ ('Responses.' + vm.metadata.translationLabel | translate).replace('%s', vm.metadata.userFirstName) }}
	</p>
</div>
<div *ngIf="!vm.metadata" [ngSwitch]="vm.message.postType">
	<ng-container *ngIf="!vm.isPreview">
		<div class="chat-message-container"
			 (mouseenter)="onMouseEnter(message)"
			 (mouseleave)="onMouseLeave(message)"
			 (click)="onMessageClick(message)"
			 #messageContainer>

			<div class="chat-message-inner-container">
				<p id="chatSimpleTextMessageItem"
				   *ngSwitchCase="'TEXT'"
				   style="white-space: pre-wrap;"
				   class="chatSimpleTextMessageItem c-text c-text--wrap"
				   [ngClass]="{'c-text--bold': isBold, 'c-message-deleted': message.deleted}"
				   [innerHtml]="message.content | linkify">
				</p>
				<button class="dots-btn-horizontal"
						*ngIf="!message.deleted && (vm.isDesktop ? message.showDots && (vm.user.id === message.user.id) && !!!message.aiSessionId : (vm.user.id === message.user.id) && !!!message.aiSessionId)"
						(click)="toggleActions(message, $event, messageContainer)">
					…
				</button>

				<div class="chat-actions-menu"
					 *ngIf="message.showActions"
                     (mouseleave)="onMouseLeaveMenu(message)"
                     (click)="$event.stopPropagation()">
					<button *ngIf="message.user.id === vm.user?.id" (click)="editMessage(message)">
                        ✏️ {{ 'Chats.Other.Edit' | translate }}
                    </button>
					<button (click)="deleteMessage(message)">
                        🗑 {{ 'Chats.Other.Delete' | translate }}
                    </button>
				</div>
			</div>

		</div>
	</ng-container>
	<ng-container *ngIf="vm.isPreview">
		<p *ngSwitchCase="'TEXT'" class="c-text c-text--wrap c-text--cut" [ngClass]="{'c-text--bold' : vm.isBold}">{{vm.message.content}}</p>
	</ng-container>
	<p id="chatCallMessageItem" *ngSwitchCase="'CALL'" class="c-text" [ngClass]="{'c-text--cut c-text--gray': vm.isPreview}"><i class="o-icon o-icon--video" aria-hidden="true"></i> {{ vm.getCallingMessage(vm.message) }}<span *ngIf="vm.message.duration"> ({{ vm.message.duration || 0 }}{{ 'Chats.Other.Seconds' | translate }})</span></p>
	<p id="chatImageMessageItem" *ngSwitchCase="'PICTURE'" class="c-text"><i class="o-icon o-icon--image" aria-hidden="true"></i></p>
	<p id="chatVideoMessageItem" *ngSwitchCase="'VIDEO'" class="c-text"><i class="o-icon o-icon--video" aria-hidden="true"></i></p>
	<p id="chatDocumentMessageItem" *ngSwitchCase="'DOCUMENT'" class="c-text"><i class="o-icon o-icon--file1" aria-hidden="true"></i></p>
	<ng-container *ngIf="vm.isMessageOnly">
		<p id="chatAudioMessageItem" *ngSwitchCase="'AUDIO'" class="c-text" [ngClass]="{'c-text--bold' : vm.isBold, 'c-text--cut': vm.isPreview}">{{ 'Sidebar.Content.Audio_Message' | translate }}</p>
	</ng-container>
	<ng-container *ngIf="!vm.isMessageOnly">
		<audio-player *ngSwitchCase="'AUDIO'" [attr.data-source]="vm.message.source || vm.message.fileUrl"></audio-player>
	</ng-container>
</div>
<div *ngIf="!vm.isPreview" [ngClass]="{'c-message--right': vm.user?.id===vm.message.user.id}" >
	<i *ngIf="vm.message.edited && !vm.message.deleted"
	   class="o-icon o-icon--edit u-no-mr c-text c-text--sm c-text--main"
	   style="cursor: default; font-size: 0.6em"
	   aria-hidden="true">
	</i>
	<a *ngIf="vm.isServiceProvider" href="javascript:void(0)" (click)="vm.translate(vm.message)"
		[ngClass]="{'c-message__content--s5': vm.message.isTranslating}"
		alt="Translate"
		style="min-width: 12px; min-height: 12px; display: inline-block; vertical-align: middle; margin-right: 5px; background-size: contain; background-repeat: no-repeat; margin-left: 4px;"
		[ngStyle]="{'background-image': 'url(' + getSvgDataUrl(vm.user?.id === vm.message.user.id ? 'black' : 'white') + ')'}">
	</a>
	<span id="chatBotGeneratedRight" *ngIf="vm.message.aiSessionId && vm.user?.id===vm.message.user.id && vm.isServiceProvider" class="u-osr-xs c-text c-message--footer">{{'Chats.Other.Ai_Generated_Message' | translate}}</span>
    <span id="chatMessageDateTimeLabel" class="c-text c-message--footer">{{vm.message.created | date:'HH:mm'}}</span>
    <span id="chatBotGeneratedLeft" *ngIf="vm.message.aiSessionId && vm.user?.id!==vm.message.user.id && !vm.isServiceProvider" class="u-osl-xs c-text c-message--footer">{{'Chats.Other.Ai_Generated_Message' | translate}}</span>
    <span id="chatMessageSeenIcon" *ngIf="vm.user?.id===vm.message.user.id" class="u-osl-xs c-text c-text--gray c-text--bold c-message--footer" [ngClass]="{'c-message--seen' : vm.message.id <= vm.lastSeen}">&check;</span>
</div>
